import React, { useEffect } from "react";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import { getFacilities } from "../../service/endpoint-manager";
import { MAX_DROPDOWN_HEIGHT } from "../../types/micellinous-constants";

function FacilityFilter({
  selectedFacility,
  setSelectedFacility,
  facilities,
  setFacilities,
}) {
  useEffect(() => {
    const getFacilitiesList = async () => {
      try {
        const response = await getFacilities();
        if (response.data.status) {
          setFacilities(response.data.body);
        }
      } catch (error) {
        console.error("Error fetching facilities: ", error);
      }
    };
    getFacilitiesList();
  }, []);

  const handleFacilityChange = (event) => {
    setSelectedFacility(event.target.value);
  };

  return (
    <FormControl style={{ width: "70%" }}>
      <InputLabel id="facility-select-label">Facility</InputLabel>
      <Select
        labelId="facility-select-label"
        id="facility-select"
        value={selectedFacility}
        onChange={handleFacilityChange}
        MenuProps={{
          style: {
            maxHeight: MAX_DROPDOWN_HEIGHT,
          },
        }}
      >
        <MenuItem value="all">All</MenuItem>
        {facilities.map((facility, i) => (
          <MenuItem key={i} value={facility.name}>
            {facility.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default FacilityFilter;
